/* eslint-disable import/no-duplicates */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */

import { faFilter, faSearch } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import * as React from 'react';
import { ChangeEvent } from 'react';
import Select from 'react-select';
import ReactTable, { AccessorFunction, Column, Filter, Instance as ReactTableInstance, TableProps } from 'react-table';
import 'react-table/react-table.css';
import { Button } from 'reactstrap';

import Icon from '../utils/icon';

import { debounce } from 'helpers/debounceHelper';
import { replaceValuesWith } from 'helpers/exportHelper';
import { XlsxTableExporter } from './xlsxTableExporter';
import { PreviousButton, NextButton } from './buttons';
import styles from './appTable.module.scss';

const FILTER_ALL_COLUMN_ID = 'all';

export interface AppTableOwnProps extends TableProps {
  onFilterChange?: (filteredRows: any[], allRows: any[], filters: any[]) => void;
  tableHeaderChildren?: JSX.Element | string;
  tableHeaderButtons?: JSX.Element;
  tableName?: string;
  id?: string;
  cacheFilters?: string[];
  filters?: JSX.Element;
}

export interface AppTableColumn extends Column {
  dropdownFilter?: boolean;
  charactersLength?: number;
}

interface AppTableState {
  columns: AppTableColumn[];
  filtered: Filter[];
  showFilters: boolean;
}

export class AppTable extends React.Component<Partial<AppTableOwnProps>, AppTableState> {
  public reactTable: ReactTableInstance;

  public constructor(props: any) {
    super(props);

    this.state = {
      columns: this.processedColumns(this.props.columns),
      filtered: this.getInitialFilters(),
      showFilters: false,
    };

    this.getTableDataForExport = this.getTableDataForExport.bind(this);
  }

  public componentDidMount() {
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    this.notifyFilterChange();
  }

  // eslint-disable-next-line camelcase
  public async UNSAFE_componentWillReceiveProps(props: any) {
    await this.setState({
      columns: this.processedColumns(props.columns),
    });
  }

  public componentDidUpdate(prevProps: any, nextProps: any) {
    if (super.componentDidUpdate) {
      super.componentDidUpdate(prevProps, nextProps);
    }
    this.notifyFilterChange();
  }

  private getInitialFilters = () => {
    const cachedFilters = this.loadCachedFilters();
    const { defaultFiltered = [] } = this.props;

    const allFilters = this.filtersToObject([
      { id: FILTER_ALL_COLUMN_ID, value: '' },
      ...defaultFiltered,
      ...cachedFilters,
    ]);

    return this.filtersToArray(allFilters);
  };

  public setFilters = (filters: AppTableState['filtered']) => {
    if (filters.find(({ id }) => id === FILTER_ALL_COLUMN_ID)) {
      this.setState({ filtered: filters });
    } else {
      this.setState({ filtered: [...filters, { id: FILTER_ALL_COLUMN_ID, value: '' }] });
    }
  };

  private getTableDataForExport() {
    return JSON.parse(
      JSON.stringify(
        this.reactTable.getResolvedState().sortedData,
        replaceValuesWith({ values: [null, 'n/a'], replaceWith: '' }),
      ),
    );
  }

  private getEndColumns() {
    return this.state.columns.reduce((result, c) => {
      if (c.columns) {
        return [...result, ...c.columns];
      }

      return [...result, c];
    }, []);
  }

  private filtersToArray = (filters: { [key: string]: any }) => {
    return Object.entries(filters).map(([key, value]) => ({ id: key, value }));
  };

  private filtersToObject = (filters: Array<{ id: string; value: any }>) => {
    return filters.reduce((acc, { id, value }) => ({ ...acc, [id]: value }), {});
  };

  private handleFilterChange = (filterId: string, value: any) => {
    this.setState(prev => {
      const nextFilters = [...prev.filtered.filter(({ id }) => id !== filterId), { id: filterId, value }];

      return {
        filtered: nextFilters,
      };
    });
  };

  private loadCachedFilters = () => {
    const { id, cacheFilters } = this.props;

    if (id && cacheFilters) {
      try {
        const cachedFilters = localStorage.getItem(id);

        return cachedFilters ? JSON.parse(cachedFilters) : [];
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('cannot load cached filters');

        return [];
      }
    }

    return [];
  };

  private onSearchChange = (filterEvent: ChangeEvent<HTMLInputElement>) => {
    filterEvent.persist();
    debounce(() => {
      this.handleFilterChange(FILTER_ALL_COLUMN_ID, filterEvent.target.value);
      const expanded = Array.from({ length: this.reactTable.state.data.length }).reduce(
        // @ts-ignore
        (obj, currentValue, index: number) => ({ ...obj, [index]: true }),
        {},
      );

      this.reactTable.setState({ expanded });
    }, 500);
  };

  private notifyFilterChange = () => {
    if (this.props.onFilterChange && this.reactTable) {
      this.props.onFilterChange(
        this.reactTable.getResolvedState().sortedData,
        this.reactTable.getResolvedState().resolvedData,
        this.reactTable.getResolvedState().filtered,
      );
    }
  };

  private searchThroughAllColumns = (filter: Filter, row: any) => {
    let currentRowMatches = this.getEndColumns().reduce((matchSoFar, column: any) => {
      const columnValue = row[column.pivotId || column.id];

      return matchSoFar || this.searchValueForFilterWords(filter, columnValue);
    }, false);

    if (!currentRowMatches && row._subRows) {
      currentRowMatches = row._subRows.reduce(
        (m: boolean, sr: any) => m || this.searchThroughAllColumns(filter, sr),
        currentRowMatches,
      );
    }

    return currentRowMatches;
  };

  private cacheFilters = (nextFilters: Filter[]) => {
    const { id, cacheFilters } = this.props;

    if (cacheFilters && cacheFilters.length) {
      try {
        localStorage.setItem(id, JSON.stringify(nextFilters));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('filters cache failed');
      }
    }
  };

  private searchValueForFilterWords(filter: Filter, value: string) {
    if (!value) {
      return false;
    }
    const filterWords = filter.value
      .toString()
      .toLowerCase()
      .split(' ');
    const valueToFilter = value.toString().toLowerCase();

    return filterWords.reduce(
      (matchedSoFar: boolean, word: string) => matchedSoFar && valueToFilter.indexOf(word) >= 0,
      true,
    );
  }

  private addDropdownFilters(column: AppTableColumn) {
    if (column.dropdownFilter) {
      if (!column.accessor || typeof column.accessor !== 'function') {
        throw new Error('Dropdown filter is only accepted on columns with functions for accessors');
      }
      const columnAccessor = column.accessor as AccessorFunction;
      const defaultOption = { value: 0, label: 'All' };
      const options = _.uniq(this.props.data.map(d => columnAccessor(d)))
        .sort()
        .map(v => ({ value: v, label: v }));

      column.Filter = () => {
        const selectOnChange = ({ value }: any) => {
          this.handleFilterChange(column.id, value);
        };

        const filterValue = this.state.filtered.find(({ id }) => id === column.id);
        const value = filterValue ? options.find(option => option.value === filterValue.value) : defaultOption;

        return (
          <Select
            options={[defaultOption, ...options]}
            onChange={selectOnChange}
            classNamePrefix="filterSelect"
            defaultValue={defaultOption}
            menuShouldBlockScroll
            menuPortalTarget={document.body}
            value={value}
          />
        );
      };
      column.filterMethod = (filter: any, row: any) => {
        return filter.value === 0 || filter.value === row[filter.id];
      };
      column.filterable = true;
    }

    if (this.props.data.length > 0) {
      delete column.dropdownFilter;
    }
  }

  private processedColumns(columns: AppTableColumn[]): Column[] {
    return [
      ...columns.map(this.processColumn.bind(this)),
      {
        Header: 'All',
        accessor: () => null,
        className: styles.hiddenCell,
        columns: [
          {
            className: styles.hiddenCell,
            headerClassName: styles.hiddenCell,
            id: FILTER_ALL_COLUMN_ID,
          },
        ],
        headerClassName: styles.hiddenCell,
      },
    ];
  }

  private processColumn(column: AppTableColumn): Column {
    if (column.columns) {
      column.columns = column.columns.map(this.processColumn.bind(this));
    }
    this.addDropdownFilters(column);

    return column;
  }

  public render() {
    const { tableHeaderChildren, tableName, tableHeaderButtons, className } = this.props;
    const { columns, filtered } = this.state;
    const searchFilter = filtered.find(({ id }) => id === FILTER_ALL_COLUMN_ID);

    return (
      <div>
        {tableHeaderChildren && <div className={styles.tableHeaderChildren}>{tableHeaderChildren}</div>}
        <div className={styles.externalHandlers}>
          <div className={styles.toolbar}>
            <div className={styles.searchBox}>
              <input
                type="text"
                onChange={this.onSearchChange}
                className="form-control"
                placeholder="Search"
                aria-label="Search"
                defaultValue={searchFilter.value}
              />
              <Icon icon={faSearch} />
            </div>

            {this.props.filters && (
              <>
                <Button
                  className={styles.filtersButton}
                  color="link"
                  onClick={() =>
                    this.setState(prevState => {
                      return { showFilters: !prevState.showFilters };
                    })
                  }
                >
                  <Icon icon={faFilter} className={this.state.showFilters ? styles.active : styles.inactive} />
                </Button>
                {this.state.showFilters && this.props.filters}
              </>
            )}
          </div>

          <div className={styles.externalFilters}>
            <XlsxTableExporter tableName={tableName} getData={this.getTableDataForExport} />
            {tableHeaderButtons}
          </div>
        </div>
        <ReactTable
          minRows={0}
          NextComponent={NextButton}
          PreviousComponent={PreviousButton}
          {...this.props}
          defaultFilterMethod={this.searchThroughAllColumns}
          columns={columns}
          className={`${styles.appTable} ${className}`}
          ref={r => {
            this.reactTable = r as ReactTableInstance;
          }}
          onFilteredChange={(nextFilters: any[], { id }: Column, value: any) => {
            this.handleFilterChange(id, value);
          }}
          onFetchData={state => {
            this.cacheFilters(state.filtered);
            this.notifyFilterChange();
          }}
          filtered={filtered}
        />
      </div>
    );
  }
}
